export default __webpack_public_path__ + "static/media/svg-2.62e13b90.svg";